import type { FileService } from './index';
import { convertMatrixToCsvString } from '../../files/fileUtils';
import type { UploadRequest } from './types';
const mockUploads = [
  {
    s3Location: 'my-bucket-location',
    uploaderName: 'Just grate labels',
    uploaderEmail: 'emeryryan1@gmail.com    ',
    description: 'Images of labels shredded by cheese graters.  This is our core business',
    originalFileName: 'Uploaded_data.csv',
    uploadDate: 1591345459829,
  },
];

const mockCSVData = [
  ['column1', 'column2', 'column3'],
  ['some data I uploaded', 'some more info', 'cool stuff'],
];
export const mockFileService: FileService = {
  fetchUploads: async () => {
    return mockUploads;
  },
  uploadFile: async (upload: UploadRequest) => {
    if (upload.uploaderName === 'fail') {
      throw new Error('Failed upload');
    }
    return 'fileupload';
  },
  deleteFile: async (fileId: string) => {
    return fileId;
  },
  retrieveFile: async (payload: string) => {
    const csvString = await convertMatrixToCsvString(mockCSVData);
    return Buffer.from(csvString).buffer;
  },
};
